import { render } from "./TransportersSearch.vue?vue&type=template&id=3727d28e&scoped=true"
import script from "./TransportersSearch.vue?vue&type=script&lang=js"
export * from "./TransportersSearch.vue?vue&type=script&lang=js"

import "./TransportersSearch.vue?vue&type=style&index=0&id=3727d28e&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3727d28e"]])

export default __exports__